export default __webpack_public_path__ + "static/media/licorne.1bacb7da.gif";